import {useContext} from 'react';

import SpreadsheetsContext from '../../contexts/SpreadsheetsContext';

const useSpreadsheets = () => {
  return useContext(SpreadsheetsContext);
};

export default useSpreadsheets;
